// extracted by mini-css-extract-plugin
module.exports = {"section":"App_section__S0_NM"};